import React from 'react';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';

export const TextFormFieldError = ({ error }: { error?: string }) => {
  return error ? (
    <Body
      component="span"
      variant="caption"
      size="small"
      display="flex"
      alignItems="center"
      gap="4px"
      color="#DA291C"
    >
      <CmhcIcon type={'icon_error_outlined'} size={CmhcIconSize.SMALL} />
      <span>{error}</span>
    </Body>
  ) : (
    <></>
  );
};
